export default "__VITE_ASSET__9fdfbdbf__"